import configDev from "./config.js";

// Mode for config generation;
// - default : This is the default setup for development and deployments.
// - debug   : This is the mode used for debugging testing/staging/prod enviornments.
let mode = "default";

let configProd = {};
let configDevOverride = {};

if (mode === "debug") {
  // Define the debug environment.
  // - apc_sit       : APC SIT.
  // - apc_uat       : APC UAT.
  // - apc_prod      : APC PROD.
  // - pro_staging   : Pro Staging V2.
  // - dpd_stg       : DPD BE Staging.
  // - dpd_bl_stg    : DPD BL Staging.
  // - tp_uat        : TP UAT.
  // - tp_training   : TP UAT.
  // - tp_prod       : TP PROD.
  // - testing_v2    : Testing V2.
  let debugEnvironment = "apc_sit";
  // Try to load the debug config if not fallback to the local config.
  try {
    // -------------------------------------------------------------------------------------------------------
    // *** Note - Only uncomment the lines below when debugging locally. Please don't push any changes here.
    // -------------------------------------------------------------------------------------------------------
    // const prodConfig = 'config.prod.js'
    // configProd = require('./server_configs/' + debugEnvironment + '.' + prodConfig).default
    // console.log('%copenFleet - Running in Debug Mode : ' + debugEnvironment, 'background: orange; padding: 5px; color: #fff', configProd)
    // -------------------------------------------------------------------------------------------------------
  } catch (ex) {
    console.log("%copenFleet - Debug Config Not Found : " + debugEnvironment + ". (Falling back to development config.)", "background: red; padding: 5px; color: #fff");
  }
} else {
  if (process.env.NODE_ENV === "production") {
    // Try to load the config.prod.js if not fallback to the local config.
    try {
      configProd = require("./config.prod.js").default;
      console.log("%copenFleet - Running in Production Mode.", "background: #9ACD32; padding: 5px; color: #fff");
    } catch (ex) {
      console.log("%copenFleet - Prod Config Not Found. Falling back to development config. (N.B. Ignore this message for DEV environments.)", "background: red; padding: 5px; color: #fff");
    }
  } else if (process.env.NODE_ENV === "development") {
    //option to override config in development env
    if (process.env.REACT_APP_DEV_CONFIG === "OVERRIDE") {
      configDevOverride = require("./config.js").default;
      console.log("%copenFleet - Running in Development (Override) Mode.", "background: #3fa9f5; padding: 5px; color: #fff");
    } else {
      console.log("%copenFleet - Running in Development Mode.", "background: #3fa9f5; padding: 5px; color: #fff");
    }
  } else {
    console.log("%copenFleet - Running in " + process.env.NODE_ENV, "background: red; padding: 5px; color: #fff");
  }
}

// Define the config structure.
var config = {
  // platform: configDev.app.processId,
  app: configDev.app,
  apiAddress: configProd.apiAddress || configDevOverride.apiAddress || configDev.apiAddress,
  virtualPath: configProd.virtualPath || configDevOverride.virtualPath || configDev.virtualPath,
  websocketConfig: configProd.websocketConfig || configDevOverride.websocketConfig || configDev.websocketConfig,
  authMethods: configProd.apiAddress ? configProd.authMethods : configDev.authMethods,
  googleAPIKey: configProd.googleAPIKey || configDev.googleAPIKey,
  environmentName: configProd.apiAddress ? configProd.environmentName : configDev.environmentName,
  ui: configDev.ui,
  configOverride: configProd.apiAddress ? true : false,
  plugins: configProd.apiAddress ? configProd.plugins : configDev.plugins,
};

export { config };
